import { Mapper } from 'src/base/mapper'
import { PaymentTermsTypeEntity } from 'src/data/entities/client.entity'
import { PaymentTermsTypeModel } from 'src/domain/models/client.model'

export class PaymentTermsMapper extends Mapper<PaymentTermsTypeEntity, PaymentTermsTypeModel> {
	mapFrom(param: PaymentTermsTypeEntity): PaymentTermsTypeModel {
		return this.resultData(param)
	}

	mapTo(param: PaymentTermsTypeModel): PaymentTermsTypeEntity {
		return this.resultData(param)
	}

	resultData(param: PaymentTermsTypeEntity | PaymentTermsTypeModel) {
		return {
			id: param.id,
			name: param.name,
			value: param.value,
		}
	}
}
